import React from "react"
import Responsive from 'react-responsive'

const Mobile = ({ children }) => <Responsive maxWidth={766} children={children} />
const Desktop = ({ children }) => <Responsive minWidth={767} children={children} />

export default ({ children }) =>
    <div>
        <Desktop>
            <div style={{
                margin: `50px 0`,
                width: `65%`
            }}>
                { children }
            </div>
        </Desktop>
        <Mobile>
            <div style={{
                margin: `50px 0`,
                width: `100%`
            }}>
                { children }
            </div>
        </Mobile>
    </div>


// WEBPACK FOOTER //
// ./src/components/Content.js